import React, {useState} from 'react';
import * as Yup from 'yup';
import {appointmentLocations} from 'src/form-inputs/appointment-location-input';
import CheckboxItemsInput from 'src/hook-form/checkbox-input';
import ListItemSeparator from 'src/common-components/separator';
import {CollapsibleFilterItem, Filters} from 'src/design-system';
import {Patient} from 'src/models';
import {useTranslations} from 'src/providers/translation';
import {Text, View} from 'react-native';
import {Typography} from 'src/styles';
import {useStyle} from 'src/providers/style';
import {Separator} from 'src/common-components/atoms';
import {Controller, useForm} from 'react-hook-form';
import Form from 'src/hook-form/form';
import DateInput from 'src/hook-form/date-input';

const NotesDueFilterMenu = ({setFilters, filters, clients, staff}: any) => {
  const translations = useTranslations();
  const styles = useStyle();

  const validationSchema = Yup.object({});
  const initialValues = filters;

  const methods = useForm({
    defaultValues: filters,
  });

  const [visible, setVisible] = useState<boolean>(false);

  const clientArr = clients.map((patient: Patient) => ({
    value: patient?.id,
    label: `${patient?.firstName} ${patient?.lastName}`,
  }));
  const staffArr = staff.map((_staff: any) => ({
    value: _staff?.id,
    label: `${_staff?.firstName} ${_staff?.lastName}`,
  }));
  const locationArr = appointmentLocations.map((_location: any) => ({
    value: _location?.value,
    label: _location?.label,
  }));

  const notificationNumberCount = () => {
    const selectedFilter = filters;
    let result = 0;
    for (const key of Object.keys(selectedFilter)) {
      if (Array.isArray(selectedFilter[key])) {
        result += selectedFilter[key].length;
      }
    }
    return result;
  };

  const filterSubmit = (payload: any) => {
    setFilters(payload);
    setVisible(false);
  };

  const filterCancelled = () => {
    setFilters({
      ...initialValues,
      clients: [],
      staff: [],
      locations: [],
    });
    setVisible(false);
  };

  return (
    <Filters
      open={visible}
      setOpen={setVisible}
      notificationNumberCount={notificationNumberCount}
      onDismiss={() => setVisible(false)}>
      <Form
        handleSubmit={methods.handleSubmit(filterSubmit, filterCancelled)}
        cancelled={filterCancelled}
        initialValues={initialValues}
        validationSchema={validationSchema}
        saveText={translations('apply')}
        cancelText={translations('reset')}>
        <Text
          style={[
            Typography.P1_MEDIUM,
            styles.textColorPrimary,
            styles.marginSMBottom,
          ]}>
          Date Range
        </Text>
        <Separator height={10} />
        <View style={[styles.flex, styles.container]}>
          <Controller
            control={methods.control}
            rules={{}}
            render={({field: {onChange, value}}) => (
              <DateInput
                label={translations('start_date')}
                value={value}
                onChange={onChange}
                required={false}
                style={styles.flex}
              />
            )}
            name="startDate"
          />
          <Separator width={10} />
          <Controller
            control={methods.control}
            rules={{}}
            render={({field: {onChange, value}}) => (
              <DateInput
                label={translations('end_date')}
                value={value}
                onChange={onChange}
                required={false}
                style={styles.flex}
              />
            )}
            name="endDate"
          />
        </View>
        <Separator height={10} />
        <ListItemSeparator />
        <CollapsibleFilterItem title={translations('client')}>
          <Controller
            control={methods.control}
            rules={{}}
            render={({field: {onChange, value}}) => {
              return (
                <CheckboxItemsInput
                  allowSelectAll={true}
                  value={value}
                  onChange={onChange}
                  items={clientArr}
                />
              );
            }}
            name="clients"
          />
        </CollapsibleFilterItem>
        <ListItemSeparator />
        <CollapsibleFilterItem title={translations('staff')}>
          <Controller
            control={methods.control}
            rules={{}}
            render={({field: {onChange, value}}) => {
              return (
                <CheckboxItemsInput
                  allowSelectAll={true}
                  value={value}
                  onChange={onChange}
                  items={staffArr}
                />
              );
            }}
            name="staff"
          />
        </CollapsibleFilterItem>
        <ListItemSeparator />
        <CollapsibleFilterItem title={translations('place_of_service')}>
          <Controller
            control={methods.control}
            rules={{}}
            render={({field: {onChange, value}}) => (
              <CheckboxItemsInput
                allowSelectAll={true}
                value={value}
                onChange={onChange}
                items={locationArr}
              />
            )}
            name="locations"
          />
        </CollapsibleFilterItem>
      </Form>
    </Filters>
  );
};

export default NotesDueFilterMenu;
